/* screens/analytics/NameCell.jsx — содержимое ячейки «имя + действие».

   Что чинит (задача 10). В ABC кнопка «Исключить из анализа» стояла в строке
   ПОСЛЕ текста названия, а ячейка резала всё, что не влезло в 260px
   (`max-width; overflow: hidden; nowrap`). Название на 120 символов уводило
   кнопку за обрезку: замер 01.10 на 1740px — ячейка 513…773, кнопка на x=1443.
   Действие пропадало ровно у тех позиций, ради которых оно и нужно (длинные
   модификаторы, упаковка, «соус к…»).

   Как теперь. Флекс в пределах ячейки: текст ужимается первым и режется
   многоточием (полное имя — в подсказке), действие — отдельный несжимаемый
   элемент у правого края. Кнопка доступна при ЛЮБОЙ длине названия и любой
   ширине столбца, в том числе после ручной правки ширины и в закреплённой
   колонке. На тач-экранах и в карточном режиме действие видно без наведения,
   а в карточке имя переносится (analytics-redesign.css).

   Один компонент на раздел: строка сотрудника «Персонала» (скрытие пары
   «сотрудник + должность», задача 13) берёт его же. */
import React from 'react';

/** name — полное название (текст и подсказка); title — своя подсказка;
 *  children — своё содержимое текста вместо `name` (иконка, вторая строка);
 *  action — узел действия (кнопка); textClassName — класс текста по месту. */
export function NameCell({ name, title, action, children, className = '', textClassName = '' }) {
  return (
    <span className={'an-namecell' + (className ? ' ' + className : '')}>
      <span className={'an-namecell__text' + (textClassName ? ' ' + textClassName : '')}
        title={title != null ? title : (name == null ? undefined : String(name))}>
        {children != null ? children : name}
      </span>
      {action ? <span className="an-namecell__act">{action}</span> : null}
    </span>
  );
}
